import type { Recommendation, Recommendations } from 'shared';
import { formatTime } from '@/lib/percurso';

/** Whether there is anything to show: switched on, enough history, a suggestion. */
export function hasSuggestions(data: Recommendations | undefined): data is Recommendations {
  return !!data && data.enabled && data.ready && (data.suggestions ?? []).length > 0;
}

export function nextSession(iso: string): string {
  const day = new Date(iso).toLocaleDateString('pt-PT', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'Europe/Lisbon',
  });
  return `${day}, ${formatTime(iso)}`;
}

/** Why an activity is suggested, in a sentence. */
export function reasonText(r: Recommendation): string {
  if (r.reason === 'peers' && r.becauseActivity) {
    return r.peers === 1
      ? `Um Digger que também fez ${r.becauseActivity} foi a esta atividade.`
      : `${r.peers} Diggers que também fizeram ${r.becauseActivity} foram a esta atividade.`;
  }
  return `Das mais procuradas no ${r.digitalCenterName}: ${r.peers} ${r.peers === 1 ? 'Digger' : 'Diggers'} nos últimos três meses.`;
}

/** The card's subtitle: why these, as a whole. */
export function cardSubtitle(data: Recommendations): string {
  return data.suggestions.every((r) => r.reason === 'popular')
    ? 'As atividades mais procuradas nos Centros onde vai.'
    : 'A partir do que fizeram outros Diggers com um percurso parecido.';
}
